import styled from "styled-components";
import { Blank, Message, Input, Flex, Icon, Textarea, Link } from "@evergis/ui";
import { ResourceType } from "../../ResourceType/ResourceType";
import { ResourceTypeContainer } from "../../ResourceType/styled";

export const FormSettingsContainer = styled(Blank)<{ height: string }>`
  display: flex;
  padding: 1rem;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem 0;
  max-height: ${({ height }) => height} !important;

  label {
    margin-bottom: 0 !important;
  }
`;

export const SettingsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Hint = styled(Message)`
  border: none;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.xSmall};

  ${Link} {
    color: ${({ theme: { palette } }) => palette.primary} !important;
    pointer-events: none;
    cursor: default;
  }
`;

export const SmallHintText = styled.div`
  font: ${({ theme: { fonts } }) => fonts.small};
  opacity: 0.54;
  margin-bottom: 0.25rem;
`;

export const FormatInput = styled(Input)`
  border: none;
  font-size: 0.75rem;
`;

export const FormatInputRow = styled(SettingsRow)`
  margin-left: 1rem;

  label {
    position: relative;
    top: 0.25rem;
  }
`;

export const StringFormSettingsContainer = styled(FormSettingsContainer)`
  padding: 0;
  justify-content: unset;
  height: auto;
`;

export const StringFormSettingsContentContainer = styled.div`
  padding: 1rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem 0;
  box-sizing: border-box;
`;

export const StringResourceType = styled(ResourceType)`
  margin-bottom: 0;
  padding: 1rem;
  box-sizing: border-box;

  ${ResourceTypeContainer} {
    margin-right: 0.5rem;
  }
`;

export const Label = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
  font-size: 12px;
  margin-bottom: 0.25rem;
`;

export const ImageFormatPreviewContainer = styled(Flex)`
  align-items: center;
`;

export const ImagePreview = styled(Flex)`
  align-items: center;
  justify-content: center;
  background-color: #f6f6f6;
  color: #b3b3b3;
  flex-direction: column;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  margin-right: 0.5rem;
`;

export const ImagePreviewIcon = styled(Icon)`
  color: #b3b3b3;
`;

export const AttributeDescriptionContainer = styled.div`
  position: relative;
`;

export const DescriptionTextarea = styled(Textarea)`
  min-height: 4rem;
  max-height: 12rem;
`;

export const LinkIconContainer = styled.div`
  position: absolute;
  right: 0;
  top: -6px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  margin-left: auto;
`;

export const CustomBlank = styled.div<{ maxHeight?: string }>`
  pointer-events: auto;
  max-height: ${({ maxHeight }) => (maxHeight ? "40vh" : "unset")};
  width: 20.5rem;

  @media screen and (max-width: 992px) {
    width: 14rem;
  }
`;

export const AttributeSelectorContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem 0;
`;
